/*
  Grilluxe Product Gallery — minimales Vanilla-JS, kein Slider/Library.
  Nachbau von ProductDetail.tsx useState(activeImage): Klick auf Thumbnail wechselt
  das Hauptbild und markiert das aktive Thumbnail visuell (border-gold).

  Live Polish — Bugfix: Das Hauptbild trägt (von Shopifys image_tag) ein srcset
  für DAS URSPRÜNGLICHE Bild. Setzt man nur `.src`, bleibt `srcset` bestehen und
  der Browser rendert laut Responsive-Image-Algorithmus weiter einen der (jetzt
  falschen) srcset-Kandidaten statt des neu gesetzten `src` (per Live-Test via
  `currentSrc` bestätigt). Fix: srcset/sizes beim Bildwechsel entfernen, damit
  `src` wieder greift.
*/
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-product-gallery]").forEach(function (gallery) {
    var mainImage = gallery.querySelector("#ProductMainImage");
    var thumbs = gallery.querySelectorAll("[data-thumb]");
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var fullSrc = thumb.getAttribute("data-full-src");
        if (!fullSrc) return;
        mainImage.removeAttribute("srcset");
        mainImage.removeAttribute("sizes");
        mainImage.src = fullSrc;
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  });
});
